// @flow
import { has } from "../utils/helpers/objects";
import { getBasePathModularUI } from "../constants";

import type Parameter from "../models/parameter/Parameter";
import type { ModelOptions } from "../models";

/**
 */
class ModularUIResponse {
  _key: string = "unknown";
  _data: Object;
  _contributions: Object;
  _locale: string = "en";
  _parameters: Array<Parameter> = [];
  _contextPath: string = getBasePathModularUI();
  _origin: string = "";

  /**
   */
  static create(input: {
    key: string,
    data: Object,
    contributions: Object,
    origin?: string,
    contextPath?: string,
  }): ModularUIResponse {
    const response = new ModularUIResponse();

    if (has(input, "data") && has(input, "contributions")) {
      const [dataKey] = Object.keys(input.data);
      const [contributionsKey] = Object.keys(input.contributions);

      response.key = input.key ?? contributionsKey;
      response.data = input.data?.[dataKey];
      response.contributions = input.contributions?.[contributionsKey];
      response.origin = input.origin;
      response.contextPath = input.contextPath;
    }

    return response;
  }

  /**
   */
  get modelOptions(): ModelOptions {
    return {
      origin: this.origin,
      contextPath: this.contextPath,
    };
  }

  /**
   */
  set origin(origin: ?string) {
    this._origin = origin ?? "";
  }

  /**
   */
  get origin(): string {
    return this._origin;
  }

  /**
   */
  set contextPath(contextPath: ?string) {
    this._contextPath = contextPath ?? getBasePathModularUI();
  }

  /**
   */
  get contextPath(): string {
    return this._contextPath;
  }

  /**
   */
  set locale(locale: string) {
    this._locale = locale;
  }

  /**
   */
  get locale(): string {
    return this._locale;
  }

  /**
   */
  set key(key: string) {
    this._key = key;
  }

  /**
   */
  get key(): string {
    return this._key;
  }

  /**
   */
  set data(data: Object) {
    this._data = data;
  }

  /**
   */
  get data(): Object {
    return this._data;
  }

  /**
   */
  set contributions(contributions: Object) {
    this._contributions = contributions;
  }

  /**
   */
  get contributions(): Object {
    return this._contributions;
  }

  /**
   */
  set parameters(parameters: Array<Parameter>) {
    this._parameters = parameters;
  }

  /**
   */
  get parameters(): Array<Parameter> {
    return this._parameters;
  }

  /**
   */
  static rehydrate(data: {
    key: string,
    locale: string,
    data: Object,
    contributions: Object,
    origin?: string,
    contextPath?: string,
  }): ModularUIResponse {
    const modelData = new ModularUIResponse();

    modelData.origin = data.origin;
    modelData.contextPath = data.contextPath;
    modelData.locale = data.locale;
    modelData.key = data.key;
    modelData.data = data.data;
    modelData.contributions = data.contributions;

    return modelData;
  }
}

export default ModularUIResponse;
